// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"e1fcb884","977":"9257ea84"}[chunkId] + ".chunk.js";
};